'use strict';

var fitvids = require('fitvids');

module.exports = {
    init: function() {
        fitvids('.js-fit-video, .s-prose');
    }
};
